import {postRequest, putRequest} from "@services/api/axiosHandler";
import pageValidation from "@services/validations/pageValidation";

import configurationApi from "@services/api/configuration";
import projectApi from "@services/api/project";
import store from "../../store";

import Project from "@models/project/Project";
import Configuration from "@models/project/Configuration";
import Contact from "@models/project/Contact";

import Building from "@models/building/Building";
import Unit from "@models/building/Unit";
import Room from "@models/building/Room";

import Unitairvolume from "@models/airvolumes/Unitairvolume";
import Roomairvolume from "@models/airvolumes/Roomairvolume";
import Systemselection from "@models/airvolumes/Systemselection";
import Installation from "@models/airvolumes/Installation";
import Valve from "@models/airvolumes/Valve";

export function saveProject(project, configuration = null) {
  if (project.user_id == null) {
    // Create new Project
    postRequest("project", project).then((response) => {
      if (response.status == 204) {
        store.dispatch("modalSettings/close");
        return;
      }
      Project.insert({
        data: response.data,
      });
      if (response.data.contact) {
        response.data.contact.project_id = response.data.id;
        Contact.insertOrUpdate({
          data: response.data.contact,
        });
      }
      if (configuration != null) {
        configuration.project_id = response.data.id;
        saveConfiguration(configuration, response.data.id);
      }
      return;
    });
  } else {
    // Update Project
    putRequest("project/" + project.id, project).then((response) => {
      if (response.status == 204) {
        store.dispatch("modalSettings/close");
        return;
      }
      Project.insertOrUpdate({
        data: response.data,
      });
      if (response.data.contact) {
        response.data.contact.project_id = response.data.id;
        Contact.insertOrUpdate({
          data: response.data.contact,
        });
      }
      if (configuration != null) {
        configuration.project_id = response.data.id;
        saveConfiguration(configuration, response.data.id);
      }
      return;
    });
  }
}

export function saveConfiguration(configuration) {
  if (configuration.project_id == null || configuration.description == null || configuration.description == "") {
    store.dispatch("alert/setAlert", {type: "danger", message: Lang("lang.kwl.alert.configuration_need_description")});
    store.dispatch("modalSettings/close");
    return;
  }

  const building = Building.query().withAllRecursive().first();

  if (configuration.service_id == null) {
    // Create new Configuration
    postRequest("configuration", {configuration: configuration, building: building}).then((response) => {
      if (response.status == 204) {
        store.dispatch("modalSettings/close");
        store.dispatch("alert/setAlert", {type: "danger", message: Lang("lang.kwl.alert.store_configuration_faild")});
        return;
      }
      Configuration.insert({
        data: response.data,
      });
      store.dispatch("alert/setAlert", {type: "success", message: Lang("lang.kwl.alert.store_configuration_success")});
      pageValidation.validatePossiblePages();
      return;
    });
  } else {
    // Update Configuration
    putRequest("configuration/" + configuration.id, {
      configuration: configuration,
      building: building
    }).then((response) => {
      if (response.status == 204) {
        store.dispatch("modalSettings/close");
        store.dispatch("alert/setAlert", {type: "danger", message: Lang("lang.kwl.alert.store_configuration_faild")});
        return;
      }
      Configuration.insertOrUpdate({
        data: response.data,
      });
      store.dispatch("alert/setAlert", {type: "success", message: Lang("lang.kwl.alert.store_configuration_success")});
      pageValidation.validatePossiblePages();
      return;
    });
  }
}

export function setConfiguration() {
  const configuration = window.configuration;
  const building = window.building;
  const project = window.project;

  if (project && project != null) {
    Project.insertOrUpdate({
      data: project
    });
  }
  store.dispatch("navigation/setSide", "Building");
  Building.deleteAll();
  Unit.deleteAll();
  Room.deleteAll();
  Unitairvolume.deleteAll();
  Roomairvolume.deleteAll();
  Systemselection.deleteAll();
  Installation.deleteAll();
  Valve.deleteAll();

  Building.create({
    data: building,
  });
  if (Building.all().length <= 0) {
    Building.create({
      data: {
        units: [{}],
      },
    });
    const unit = Unit.query().first();
    unit.setDefaultsByType();
  } else if (Unit.all().length <= 0) {
    Unit.create({
      data: {
        buildingId: Building.query().first().id,
      },
    });
    const unit = Unit.query().first();
    unit.setDefaultsByType();
  }

  configuration.selectedConfiguration = true;
  Configuration.create({
    data: configuration,
  });
  window.configuration = null;
  pageValidation.validatePossiblePages();
}

export function updateConfiguration() {
  var configuration = Configuration.query().where("selectedConfiguration", true).first();
  if (configuration == null || configuration == undefined || configuration.isUseraccess === true) return;
  var orm = Building.query().withAllRecursive().first();
  var project = Project.query().where("id", configuration.project_id).first();
  var contact = Contact.query().where("project_id", configuration.project_id).where("type", 1).first();

  if (isNaN(project.id)) project.id = null;
  if (isNaN(configuration.id)) configuration.id = null;
  if (isNaN(configuration.kwl_id)) configuration.kwl_id = null;
  configuration.service_id = configuration.id;
  configuration.id = configuration.kwl_id;

  configurationApi
    .createConfiguration({
      project: project,
      configuration: configuration,
      contact: contact,
      orm: orm,
    })
    .then((response) => {
      response.data["$id"] = null;
      response.data.configuration["$id"] = null;
      response.data.configuration.project_id = response.data.id;
      response.data.contact.project_id = response.data.id;
      Project.insertOrUpdate({
        data: [
          {
            id: project.id,
            selectedProject: false,
          },
          response.data,
        ],
      });
      Configuration.insertOrUpdate({
        data: [
          {
            id: configuration["$id"],
            selectedConfiguration: false,
          },
          response.data.configuration,
        ],
      });
      Contact.insertOrUpdate({
        data: response.data.contact,
      });

      /* 			document.getElementById('closeSaveModal').click();
if(response.status >= '400'){
this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
return
}

this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.kwl.alert.store_configuration_success')})
this.update.configuration = 1
this.attempt_submit = false
this.projectStore = response.data
this.configuration = true
this.getUserProject() */
    });
}

export default {
  async getUserProjects() {
    Project.deleteAll();
    Configuration.deleteAll();
    Contact.deleteAll();

    try {
      var response = await projectApi.returnFullProjectData();

      Project.create({
        data: response,
      });

      return true;
    } catch (error) {
      return false;
    }
  },

  storeUserConfiguration() {
    var configuration = Configuration.query().where("selectedConfiguration", true).first();
    if (configuration == null || configuration == undefined || configuration.isUseraccess === true) return;
    var orm = Building.query().withAllRecursive().first();
    var project = Project.query().where("id", configuration.project_id).first();
    var contact = Contact.query().where("project_id", configuration.project_id).where("type", 1).first();

    if (isNaN(project.id)) project.id = null;
    if (isNaN(configuration.id)) configuration.id = null;
    if (isNaN(configuration.kwl_id)) configuration.kwl_id = null;
    configuration.service_id = configuration.id;
    configuration.id = configuration.kwl_id;

    configurationApi
      .createConfiguration({
        project: project,
        configuration: configuration,
        contact: contact,
        orm: orm,
      })
      .then((response) => {
        response.data["$id"] = null;
        response.data.configuration["$id"] = null;
        response.data.configuration.project_id = response.data.id;
        response.data.contact.project_id = response.data.id;
        Project.insertOrUpdate({
          data: [
            {
              id: project.id,
              selectedProject: false,
            },
            response.data,
          ],
        });
        Configuration.insertOrUpdate({
          data: [
            {
              id: configuration["$id"],
              selectedConfiguration: false,
            },
            response.data.configuration,
          ],
        });
        Contact.insertOrUpdate({
          data: response.data.contact,
        });

        /* 			document.getElementById('closeSaveModal').click();
if(response.status >= '400'){
this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
return
}

this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.kwl.alert.store_configuration_success')})
this.update.configuration = 1
this.attempt_submit = false
this.projectStore = response.data
this.configuration = true
this.getUserProject() */
      });
  },

  pageChangeStore() {
    var configuration = Configuration.query().where("selectedConfiguration", true).first();
    if (configuration == null || configuration == undefined) return;
    if (configuration.kwl_id == null) return;
    this.storeUserConfiguration();
  },
};
export const storeUserConfiguration = function () {
  var configuration = Configuration.query().where("selectedConfiguration", true).first();
  if (configuration == null || configuration == undefined || configuration.isUseraccess === true) return;
  var orm = Building.query().withAllRecursive().first();
  var project = Project.query().where("id", configuration.project_id).first();
  var contact = Contact.query().where("project_id", configuration.project_id).where("type", 1).first();

  if (isNaN(project.id)) project.id = null;
  if (isNaN(configuration.id)) configuration.id = null;
  if (isNaN(configuration.kwl_id)) configuration.kwl_id = null;
  configuration.service_id = configuration.id;
  configuration.id = configuration.kwl_id;

  configurationApi
    .createConfiguration({
      project: project,
      configuration: configuration,
      contact: contact,
      orm: orm,
    })
    .then((response) => {
      response.data["$id"] = null;
      response.data.configuration["$id"] = null;
      response.data.configuration.project_id = response.data.id;
      response.data.contact.project_id = response.data.id;
      Project.insertOrUpdate({
        data: [
          {
            id: project.id,
            selectedProject: false,
          },
          response.data,
        ],
      });
      Configuration.insertOrUpdate({
        data: [
          {
            id: configuration["$id"],
            selectedConfiguration: false,
          },
          response.data.configuration,
        ],
      });
      Contact.insertOrUpdate({
        data: response.data.contact,
      });

      /* 			document.getElementById('closeSaveModal').click();
if(response.status >= '400'){
this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
return
}

this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.kwl.alert.store_configuration_success')})
this.update.configuration = 1
this.attempt_submit = false
this.projectStore = response.data
this.configuration = true
this.getUserProject() */
    });
};

export const getUserProjects = async function () {
  Project.deleteAll();
  Configuration.deleteAll();
  Contact.deleteAll();

  try {
    var response = await projectApi.returnFullProjectData();

    Project.create({
      data: response,
    });

    return true;
  } catch (error) {
    return false;
  }
};
